module.exports = __webpack_public_path__ + "static/media/Lato-Regular.7f690e50.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Lato/Lato-Regular.ttf
// module id = 680
// module chunks = 0